var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick_gametype_box"},[_c('div',_vm._l((_vm.gametype.GameAry),function(item,index){return _c('div',{key:index,staticClass:"box_h flex_align_center",attrs:{"data-id":item.Id}},[(_vm.navid != 121 && _vm.navid != 122 && _vm.navid != 124 && _vm.navid != 126)?_c('div',{staticClass:"qu_gametype_title box_s"},[_c('p',[_vm._v(_vm._s(item.Title))])]):_vm._e(),_vm._v(" "),(_vm.navid == 121)?_c('div',{staticClass:"dice_itm"},_vm._l((item.List),function(value,index){return _c('div',{key:index,class:['box_s', value.code == 1 ? 'select_dice_img big_icon' : ''],attrs:{"data-code":value.code,"data-id":item.Id,"data-index":index},on:{"click":_vm.choiceNum}},[_c('div',{class:[
							'icon',
							value.text == '111'
								? 'dice_img111'
								: value.text == '222'
								? 'dice_img222'
								: value.text == '333'
								? 'dice_img333'
								: value.text == '444'
								? 'dice_img444'
								: value.text == '555'
								? 'dice_img555'
								: 'dice_img666' ]})])}),0):(_vm.navid == 122 || _vm.navid == 126)?_c('div',{staticClass:"dice_itm1"},_vm._l((item.List),function(value,index){return _c('div',{key:index,class:['box_s', value.code == 1 ? 'select_dice_img big_icon' : ''],attrs:{"data-code":value.code,"data-id":item.Id,"data-index":index},on:{"click":_vm.choiceNum}},[_c('div',{class:[
							'icon',
							,
							value.text == '1'
								? 'dice_img1'
								: value.text == '2'
								? 'dice_img2'
								: value.text == '3'
								? 'dice_img3'
								: value.text == '4'
								? 'dice_img4'
								: value.text == '5'
								? 'dice_img5'
								: 'dice_img6' ]})])}),0):(_vm.navid == 124)?_c('div',{staticClass:"dice_itm2"},_vm._l((item.List),function(value,index){return _c('div',{key:index,class:['box_s', value.code == 1 ? 'select_dice_img big_icon' : '', 'dice_itm_num2'],attrs:{"data-code":value.code,"data-id":item.Id,"data-index":index},on:{"click":_vm.choiceNum}},[_c('div',{class:[
							'icon',
							,
							value.text == '11'
								? 'dice_img11'
								: value.text == '22'
								? 'dice_img22'
								: value.text == '33'
								? 'dice_img33'
								: value.text == '44'
								? 'dice_img44'
								: value.text == '55'
								? 'dice_img55'
								: 'dice_img66' ]})])}),0):_c('div',{staticClass:"qu_gametype_numbox box_h box_flex"},_vm._l((item.List),function(value,index){return _c('div',{key:index,class:['box_s', value.code == 1 ? 'change_this_style big_icon' : ''],attrs:{"data-code":value.code,"data-id":item.Id,"data-index":index},on:{"click":_vm.choiceNum}},[_vm._v("\n\t\t\t\t\t"+_vm._s(value.text)+"\n\t\t\t\t")])}),0),_vm._v(" "),_c('div',{staticClass:"box_h qu_gamebtn_box"},[_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("全")]),_vm._v(" "),_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("大")]),_vm._v(" "),_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("小")]),_vm._v(" "),_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("奇")]),_vm._v(" "),_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("偶")]),_vm._v(" "),_c('div',{attrs:{"data-id":item.Id},on:{"click":_vm.btnCilck}},[_vm._v("清")])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f09f752","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subcomponents/game_type.vue
// module id = null
// module chunks = 